import { StepsProps } from '@pankod/refine-antd'
import clsx from 'clsx'

export enum PROGRAM_STATE {
  PREPARATION = 'persiapan',
  RUNNING = 'berjalan',
  ENDED = 'selesai',
}

export const getAvailableStatus = (
  status: PROGRAM_STATE | undefined,
): {
  status: [StepsProps['status'], StepsProps['status'], StepsProps['status']]
  nextState: PROGRAM_STATE | null
} => {
  if (!status) return { status: ['wait', 'wait', 'wait'], nextState: null }
  const options: Record<
    string,
    {
      status: [StepsProps['status'], StepsProps['status'], StepsProps['status']]
      nextState: PROGRAM_STATE | null
    }
  > = {
    [PROGRAM_STATE.PREPARATION]: {
      status: ['process', 'wait', 'wait'],
      nextState: PROGRAM_STATE.RUNNING,
    },
    [PROGRAM_STATE.RUNNING]: {
      status: ['finish', 'process', 'wait'],
      nextState: PROGRAM_STATE.ENDED,
    },
    [PROGRAM_STATE.ENDED]: {
      status: ['finish', 'finish', 'finish'],
      nextState: null,
    },
  }
  return options[status]
}

export const getProgressDot: StepsProps['progressDot'] = (
  dot,
  { status, index },
) => {
  switch (status) {
    case 'process':
      return <span className={clsx(index === 1 && 'animate-ping')}>{dot}</span>
    default:
      return dot
  }
}

export const secondToMinuteText = (
  second?: number | string,
  prefix = { second: 'detik', minute: 'menit' },
) => {
  if (typeof second === 'undefined' || isNaN(+second)) return '-'

  const seconds = +second % 60
  const minutes = Math.floor(+second / 60)
  return `${minutes} ${prefix.minute}${
    seconds !== 0 ? `,\n${seconds} ${prefix.second}` : ''
  }`
}
